module.exports = __webpack_public_path__ + "static/media/img_hana02.5073ec00.png";